module.exports = __webpack_public_path__ + "img/logo.3119c76d.png";